import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS  } from '@angular/material';
import * as XLSX from 'xlsx';
import { SecurityService } from 'app/services/security/security.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FiltrosRepFinanzas } from 'app/models/FiltrosRepFinanzas';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-general',
  templateUrl: './listado-general.component.html',
  styleUrls: ['./listado-general.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class ListadoOperacionesGeneralComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns =  [  
                         "OPER", 
                         "EJECUT", 
                         "COD_PROVEEDOR", 
                         "CLIENTE", 
                         "MONEDA", 
                         "FACTURA", 
                         "POLIZA", 
                         "VALOR_NOMINAL", 
                         "FECHA_VCTO", 
                         "RUC_DEUDOR", 
                         "DEUDOR", 
                         "TEM", 
                         "FECHA_OPERACION", 
                         "FECHA_VENCIMIENTO", 
                         "PLAZO", 
                         "INTERESES", 
                         "VALOR_DESCONTADO", 
                         "COMISION_GRUPO_CORIL", 
                         "EMISION_POLIZA", 
                         "SMV", 
                         "CARGO_IGV", 
                         "TOTAL_COMISIONES_SMV", 
                         "RENDIMIENTO_NETO", 
                         "IMPORTE_NETO", 
                         "OTROS", 
                         "CAVALI", 
                         "FIRMA_ELECTRONICA", 
                         "IGV_OTROS", 
                         "TOTAL_COSTOS_CORIL", 
                         "INTERESES_ANV", 
                         "COMISION_ANV", 
                         "IGV_COMISION", 
                         "IGV_INTERES", 
                         "TOTAL_DESCUENTO_A_CLIENTE", 
                         "MONTO_LIQUIDO_CLIENTE", 
                         "FINANCIAMIENTO", 
                         "RETENCION", 
                         "MONTO_TRANSF_CTA_ANV", 
                         "IMPORTE_DESEMBOLSADO_CLIENTE", 
                         "GASTOS_DE_TRANSFERENCIA", 
                         "FECHA_FACTURA_INTERES", 
                         "SERIE_FACTURA_INTERES", 
                         "NUMERO_FACTURA_INTERES", 
                         "VVTA_FACTURA_INTERES", 
                         "IGV_FACTURA_INTERES", 
                         "TOTAL_FACTURA_INTERES", 
                         "FECHA_FACTURA_COMISION", 
                         "SERIE_FACTURA_COMISION", 
                         "NUMERO_FACTURA_COMISION", 
                         "VVTA_FACTURA_COMISION", 
                         "IGV_FACTURA_COMISION", 
                         "TOTAL_FACTURA_COMISION", 
                         "FECHA_DETRACCION", 
                         "NUMERO_CONSTANCIA", 
                         "FACTURA_DETRACCION", 
                         "BASE_IMPONIBLE_DETRACCION", 
                         "DETRACCION", 
                         "DEPOSITO_DETRACCION", 
                         "NETO_DETRACCION", 
                         "NUEVA_FECHA", 
                         "DIAS_ADICIONALES", 
                         "INTERES_COMPENSATORIO", 
                         "IGV_INTERES_COMPENSATORIO", 
                         "INTERES_MORATORIO", 
                         "OTROS_CARGOS", 
                         "TOTAL_REPROGRAMACION", 
                         "FECHA_CANCELACION", 
                         "VALOR_NOMINAL_PAGO", 
                         "MONTO_PAGADO", 
                         "SALDO", 
                         "POR_DESC_LIQUIDACION", 
                         "SALDO_VN", 
                         "SALDO_IMP_OPERACION", 
                         "FECHA_LIQUIDACION", 
                         "MONTO_LIQUIDACION", 
                         "INTERES_LIQUIDACION", 
                         "MORA_LIQUIDACION", 
                         "GASTOS_LIQUIDACION", 
                         "OTROS_LIQUIDACION", 
                         "IGV_LIQUIDACION", 
                         "SALDO_LIQUIDACION", 
                         "NETO_A_DEVOLVER", 
                         "FECHA_INTERES_COMPENSATORIO", 
                         "SERIE_INTERES_COMPENSATORIO", 
                         "NUMERO_INTERES_COMPENSATORIO",
                          "VVTA_INTERES_COMPENSATORIO", 
                          "IGV_INTERES_COMPENSATORIO_C", 
                          "TOTAL_INTERES_COMPENSATORIO", 
                          "FECHA_INTERES_MORA", 
                          "SERIE_INTERES_MORA", 
                          "NUMERO_INTERES_MORA", 
                          "VVTA_INTERES_MORA", 
                          "IGV_INTERES_MORA", 
                          "TOTAL_INTERES_MORA",  
                          "TIPO_SERVICIO"
                      ];
;
headerStyle:any = [
  {cell:'A2',cells:'A1:A2',fgColor:'002060',color:'FFFFFF'},
  {cell:'B2',cells:'B1:B2',fgColor:'002060',color:'FFFFFF'},
  {cell:'C2',cells:'C1:C2',fgColor:'002060',color:'FFFFFF'},
  {cell:'D2',cells:'D1:D2',fgColor:'002060',color:'FFFFFF'},
  {cell:'E2',cells:'E1:E2',fgColor:'002060',color:'FFFFFF'},
  {cell:'F2',cells:'F1:F2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'G2',cells:'G1:G2',fgColor:'002060',color:'FFFFFF'},
  {cell:'H2',cells:'H1:H2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'I2',cells:'I1:I2',fgColor:'002060',color:'FFFFFF'},
  {cell:'J2',cells:'J1:J2',fgColor:'002060',color:'FFFFFF'},
  {cell:'K2',cells:'K1:K2',fgColor:'002060',color:'FFFFFF'},
  {cell:'L2',cells:'L1:L2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'M2',cells:'M1:M2',fgColor:'002060',color:'FFFFFF'},
  {cell:'N2',cells:'N1:N2',fgColor:'002060',color:'FFFFFF'},
  {cell:'O2',cells:'O1:O2',fgColor:'002060',color:'FFFFFF'},
  {cell:'P2',cells:'P1:P2',fgColor:'002060',color:'FFFFFF'},
  {cell:'Q2',cells:'Q1:Q2',fgColor:'FFC000',color:'FFFFFF'},
  
  {cell:'R1',cells:'R1:W1',fgColor:'00B0F0',color:'FFFFFF',title:'COMPRA DE FACTURAS CARGO ANV PERU'},
  {cell:'R2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'S2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'T2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'U2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'V2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'W2',fgColor:'00B0F0',color:'FFFFFF'},
  
  {cell:'X2',cells:'X1:X2',fgColor:'002060',color:'FFFFFF'},

  {cell:'Y1',cells:'Y1:AC1',fgColor:'002060',color:'FFFFFF',title:'COSTOS VENTA FACTURA CARGO CLIENTE'},
  {cell:'Y2',fgColor:'002060',color:'FFFFFF'},
  {cell:'Z2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AA2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AB2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AC2',fgColor:'002060',color:'FFFFFF'},

  {cell:'AD1',cells:'AD1:AH1',fgColor:'00B0F0',color:'FFFFFF',title:'INTERES Y COMISIONES'},
  {cell:'AD2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AE2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AF2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AG2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AH2',fgColor:'00B0F0',color:'FFFFFF'},

  
  {cell:'AI2',cells:'AI1:AI2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AJ2',cells:'AJ1:AJ2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AK2',cells:'AK1:AK2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AL2',cells:'AL1:AL2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AM2',cells:'AM1:AM2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AN2',cells:'AN1:AN2',fgColor:'002060',color:'FFFFFF'},

  
  {cell:'AO1',cells:'AO1:AT1',fgColor:'00B0F0',color:'FFFFFF',title:'EMISION FACTURA INTERESES'},
  {cell:'AO2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AP2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AQ2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AR2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AS2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'AT2',fgColor:'00B0F0',color:'FFFFFF'},
  
  {cell:'AU1',cells:'AU1:AZ1',fgColor:'002060',color:'FFFFFF',title:'EMISION FACTURA COMISIONES'},
  {cell:'AU2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AV2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AW2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AX2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AY2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AZ2',fgColor:'002060',color:'FFFFFF'},

  {cell:'BA1',cells:'BA1:BF1',fgColor:'002060',color:'FFFFFF',title:'PAGO DE LA DETRACCION'},
  {cell:'BA2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BB2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BC2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BD2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BE2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BF2',fgColor:'002060',color:'FFFFFF'},

  {cell:'BG2',cells:'BG1:BG2',fgColor:'002060',color:'FFFFFF'},

  
  {cell:'BH1',cells:'BH1:BN1',fgColor:'FF3399',color:'FFFFFF',title:'REPROGRAMACIONES Y OTROS CARGOS'},
  {cell:'BH2',fgColor:'FF3399',color:'FFFFFF'},
  {cell:'BI2',fgColor:'FF3399',color:'FFFFFF'},
  {cell:'BJ2',fgColor:'FF3399',color:'FFFFFF'},
  {cell:'BK2',fgColor:'FF3399',color:'FFFFFF'},
  {cell:'BL2',fgColor:'FF3399',color:'FFFFFF'},
  {cell:'BM2',fgColor:'FF3399',color:'FFFFFF'},
  {cell:'BN2',fgColor:'FF3399',color:'FFFFFF'},


  {cell:'BO1',cells:'BO1:BU1',fgColor:'002060',color:'FFFFFF',title:'PAGO DE LA DETRACCION'},
  {cell:'BO2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BP2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BQ2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BR2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BS2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BT2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BU2',fgColor:'002060',color:'FFFFFF'},

  {cell:'BV1',cells:'BV1:CC1',fgColor:'002060',color:'FFFFFF',title:'DEVOLUCIÓN DE RETENCIÓN & LIQUIDACION DE LA OPERACIÓN'},
  {cell:'BV2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BW2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BX2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BY2',fgColor:'002060',color:'FFFFFF'},
  {cell:'BZ2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CA2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CB2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CC2',fgColor:'002060',color:'FFFFFF'},

  
  {cell:'CD2',cells:'CD1:CD2',fgColor:'002060',color:'FFFFFF'},

   {cell:'CE1',cells:'CE1:CJ1',fgColor:'002060',color:'FFFFFF',title:'EMISION FACTURA INTERES COMPENSATORIO'},
  {cell:'CE2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CF2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CG2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CH2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CI2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CJ2',fgColor:'002060',color:'FFFFFF'},
  
  {cell:'CK1',cells:'CK1:CP1',fgColor:'002060',color:'FFFFFF',title:'EMISION FACTURA MORA'},
  {cell:'CK2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CL2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CM2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CN2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CO2',fgColor:'002060',color:'FFFFFF'},
  {cell:'CP2',fgColor:'002060',color:'FFFFFF'},
  
  {cell:'CQ2',cells:'CQ1:CQ2',fgColor:'002060',color:'FFFFFF'},
];
  footerStyle:any=[
    {fgColor:'808080',color:'FFFFFF',content:'TOTAL'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF',formula:'SUM',col:'H'},
  ]
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  loadingUser:boolean;
  planillas: any = [];
  dataReporte: any = [];
  dataSource: any;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  arrListaAccesos: any[] = [];
  subRepFinanzas: Subscription = new Subscription();
  DTOFiltrosRepFinanzas: FiltrosRepFinanzas = new FiltrosRepFinanzas();
  arrListaRoles: any[] = [];
  usuarioLogueado: any;
  usuarioFiltro: any;
  rolUsuario: any;
  readonly ROL_ADMIN: string = 'administrador';
  readonly ROL_COMERCIAL: string = 'comercial';
  readonly ROL_JEFATURA: string = 'jefe';
  readonly ROL_GERENCIA: string = 'gerencia';
  subLista: Subscription[] = [];
  subRol: Subscription = new Subscription();
  subAcceso: Subscription = new Subscription();
  subUser: Subscription = new Subscription();
  constructor(private reporteService: ReportesService,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus) { }

  ngOnInit() {
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('UserActive'));
    this.obtenerListaAccesos();
    this.ListadoRepFinanzas();
    this.securityService.headerStyle=this.headerStyle;
    this.securityService.footerStyle=this.footerStyle;
    this.securityService.displayedColumns=this.displayedColumns;
  }
  obtenerListaAccesos() {
    this.subRol = this.securityService.ObtenerListaRoles(this.usuarioLogueado.id_empresa).subscribe(
      (resRoles: any) => {
        this.arrListaRoles = resRoles;
        this.rolUsuario = this.arrListaRoles.find(r => r.id_roles == this.usuarioLogueado.id_roles);
        this.rolUsuario.Nombre = this.rolUsuario.Nombre.toLowerCase();

        this.subAcceso = this.securityService.ObtenerListaAccesos().subscribe(
          (resAccesos: any) => {
            this.arrListaAccesos = resAccesos;
            /*if (this.rolUsuario.Nombre.startsWith(this.ROL_JEFATURA) || this.rolUsuario.Nombre == this.ROL_GERENCIA || this.rolUsuario.Nombre == this.ROL_ADMIN) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_roles_dsc.toLowerCase() == this.ROL_COMERCIAL);
            } else if (this.rolUsuario.Nombre == this.ROL_COMERCIAL) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_user == this.usuarioLogueado.id_user);
            } else {
              this.arrListaAccesos = [];
            }*/
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "LISTA ACCESOS NO OBTENIDA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.push(this.subAcceso);

      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRol);
  }
  ListadoRepFinanzas(){
    this.loading = true;
    this.DTOFiltrosRepFinanzas.Tipo = 'data_general';
    this.subRepFinanzas = this.securityService.FiltroListadoRepFinanzas(this.DTOFiltrosRepFinanzas, this.datePipe.transform(this.fechaD, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaH, 'yyyy-MM-dd')).subscribe(
      res => {
        this.dataReporte = res;
        this.dataSource = new MatTableDataSource(this.dataReporte);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.securityService.dataBuffer = this.dataReporte;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  seleccionarUsuario(event) {
    this.loadingUser = true;
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo datos del usuario seleccionado',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    let TipoUsuario = "COM";
    this.subUser = this.securityService.ObtenerUsuarios(TipoUsuario).subscribe(
      res => {

        this.usuarioFiltro = res;
        this.usuarioFiltro = this.usuarioFiltro.filter(u => u.Nombre == event);
        this.DTOFiltrosRepFinanzas.Usuario = this.usuarioFiltro[0].Usuario;
        this.loadingUser = false;
        if (this.loadingUser == false) {
          Swal.close();
        }

      },
      (err: HttpErrorResponse) => {

        this.loadingUser = false;
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "DATOS DEL USUARIO NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subUser);
  }
}


